import { Platform, StyleSheet, Text, View } from "react-native";

export default function TermsPage() {
  if (Platform.OS === "web") {
    return (
      <iframe
        src="/terms.html"
        style={{ border: "none", height: "100vh", width: "100%" }}
      />
    );
  }

  return (
    <View style={styles.container}>
      <Text style={styles.text}>terms of service</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  text: {
    color: "#FEF7F3",
    fontSize: 24,
  },
});
